import { DropdownWUT } from '@wix/form-fields/wut';

export default DropdownWUT;
